import { connect } from "react-redux";
import { useEffect, useState, useCallback } from "react";
import { getOneBillTransactionsForSettlement, getShopOrderTransactionDetailByPsid, getShopOrderTransactionDetailById, oneBillManualSettlement } from "./OneBillManualSettlementAction";
import FormikControl from '../../layouts/Input/FormikControl'
import { Modal, Row, Col, Container, Button } from "react-bootstrap";
import { Formik, Form } from "formik";
import { VzPageContainer } from "../../layouts/VzPageContainer";
import ServerSideDataTable from "../../layouts/DataTables/ServerSideDataTable/ServerSideDataTable";
import * as Yup from "yup";
import { toast } from "react-toastify";

const OneBillManualSettlement = (props) => {
  const [currentIndex, setCurrentIndex] = useState();
  const [currentPageNo, setCurrentPageNo] = useState(0);
  const [currentPageSize, setCurrentPageSize] = useState(5);
  const [searchText, setSearchText] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);
  const [modalShow, setModalShow] = useState(false);
  const [psid, setPsid] = useState('');
  const [crudType, setCrudType] = useState('');
  const [currentEntity, setCurrentEntity] = useState({
    id : '',
    invoiceNumber: '',
    invoiceAmount: 0,
    createdDate: '',
    amount: 0,
    transactionId: '',
    newAmount: 0,
    vizShopCode: '',
    shopCode: '',
    createdBy: '',
    status: ''
  });

  useEffect(()=>{
    if(props.OnBillTransactionDetail != null)
    {
      setCurrentEntity(props.OnBillTransactionDetail);
    }
    else
    {
      setCurrentEntity(
        {
          id : '',
          invoiceNumber: '',
          invoiceAmount: 0,
          createdDate: '',
          amount: 0,
          transactionId: '',
          newAmount: 0,
          vizShopCode: '',
          shopCode: '',
          createdBy: '',
          status: ''
        }
      );
    }

  },[props.OnBillTransactionDetail])

  useEffect(()=>{
    if(props.OnBillTransactionDetailById != null)
    {
      setCurrentEntity(props.OnBillTransactionDetailById);
      setModalShow(true);
    }

  },[props.OnBillTransactionDetailById])

  const validationSchema = Yup.object().shape({  
    newAmount: Yup.string().required('New amount is required'),
    transactionId: Yup.string().required('Transaction Id is required'),
  });

  const handleSubmit = async (data) => {
    if(!data?.id)
    {
      toast.error("No unpaid 1-Bill transactions were found.");
      return;
    }

    var requestData = {
      id : data.id,
      transactionId : data.transactionId,
      newAmount : data.newAmount
    }
    await props.oneBillManualSettlement(requestData);
    setModalShow(false);    
    fetchReportData(formRequestObject());
  };

  const formRequestObject = useCallback(() => {
    return {
      pageSize: currentPageSize,
      pageNo: currentPageNo,
      searchText: searchText,
    };
  }, [currentPageSize, currentPageNo, searchText]);

  const fetchReportData = useCallback(
    (request) => {
      const finalRequest = request ?? formRequestObject();
      props.getOneBillTransactionsForSettlement(finalRequest);
    },
    [props, formRequestObject]
  );

  const getData = (page) => {
    setCurrentPageNo(page);

    const request = {
      ...formRequestObject(),
      pageNo: page,
    };

    fetchReportData(request);
  };

  const pageSizeChanged = (pageSize) => {
    setCurrentPageNo(0);
    setCurrentPageSize(pageSize);

    const request = {
      ...formRequestObject(),
      pageNo: 0,
      pageSize: pageSize,
    };

    fetchReportData(request);
  };

  const searchChanged = (text) => {
    setSearchText(text);
  };

  useEffect(() => {
    setCurrentPageNo(0);
    fetchReportData({
      pageSize: currentPageSize,
      pageNo: 0,
      searchText: searchText,
    });
  }, [searchText]);

  useEffect(() => {
    setTotalRecords(
      props.OneBillTransactionsList?.totalRecords ?? 0
    );
  }, [props.OneBillTransactionsList]);

  const columns = [
    { Header: "Viz Id", accessor: "vizShopCode" },
    { Header: "Shop Code", accessor: "shopCode" },
    { Header: "Shop Name", accessor: "shopName" },
    { Header: "Invoice Number", accessor: "vizproInvoiceNumber" },
    { Header: "Amount", accessor: "amount" },
    { Header: "PSID", accessor: "psid" },
    { Header: "TID", accessor: "tid" },
    { Header: "Status", accessor: "status" },
    {
      Header: "Action",
      accessor: "transactionId",
      Cell: (row) => (
        <div style={{ width: "106px" }}>
          <button
            onClick={() => viewSettlement(row?.cell?.value)}
            className="btn btn-sm"
          >
            <i className="fas fa-eye"></i>
          </button>
        </div>
      ),
    },
  ];

  const viewSettlement = async (id) => {
    setCrudType('view');
    props.getShopOrderTransactionDetailById(id);
  };

  const addSettlement = () => {
    setCrudType('add');
    setCurrentEntity({});
    setModalShow(true);
  };

  const getShopOrderTransactionDetailByPsid = async() =>{
    props.getShopOrderTransactionDetailByPsid(psid);
  }

  return (
    <div>
      <VzPageContainer title="1 Bill > Bank Details Form">
        <Row>
          <Col>
            <h4>
              <b>1 Bill Manual Settlement Form</b>
            </h4>
          </Col>
        </Row>

        <Row style={{ marginBottom: 30 }}>
          <Col>
            <div className="form-group">
              <Button
                className="form-btn"
                variant="primary"
                onClick={addSettlement}
              >
                Add Settlement
              </Button>
            </div>
          </Col>
        </Row>

        <Row>
          <Col>
            <ServerSideDataTable
              data={props.OneBillTransactionsList?.data ?? []}
              columns={columns}
              getTrProps={() => null}
              goToPreviousPage={getData}
              goToNextPage={getData}
              totalRecords={totalRecords}
              pageSizeChange={pageSizeChanged}
              myPageSize={currentPageSize}
              myIndex={currentIndex}
              pageNo={currentPageNo}
              searchChanged={searchChanged}
            />
          </Col>
        </Row>
      </VzPageContainer>

      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Formik
          enableReinitialize
          initialValues={currentEntity}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {(formik) => (
            <Form autoComplete="off">
              <Modal.Header closeButton>
                <Modal.Title>
                    <span style={{color:'#ea5f2d'}}>
                        1 Bill Manual Settlement
                    </span>
                </Modal.Title>
              </Modal.Header>

              <Modal.Body>
                <Container>
                  {
                    crudType !== 'view' &&
                    <Row>
                        <Col xs={12} lg={6}>
                            <div className='form-group'>
                                <FormikControl
                                    control='input'
                                    type='text'
                                    label='PSID'
                                    name='psid'
                                    maxLength={100}
                                    handleOnChange={(e) => setPsid(e)}
                                    value={psid}
                                />
                            </div>
                        </Col>
                        <Col xs={12} lg={6}>
                            <Button
                                className="btn btn-primary"
                                onClick={getShopOrderTransactionDetailByPsid}
                                style={{marginTop:'30px'}}
                                >
                                Search
                            </Button>
                        </Col>
                    </Row>
                  }
                  <Row>
                    <Col xs={6} md={6}>
                      <div className='form-group'>
                        <FormikControl
                            formik={formik}
                            readOnly={true}
                            control='input'
                            type='text'
                            label='Invoice #'
                            name='invoiceNumber'
                            handleOnChange={e => (currentEntity.invoiceNumber = e)}
                            value={currentEntity?.invoiceNumber}
                        />
                      </div>
                    </Col>
                    <Col xs={6} md={6}>
                      <div className='form-group'>
                        <FormikControl
                            formik={formik}
                            readOnly={true}
                            control='input'
                            type='text'
                            label='Invoice Amount'
                            name='invoiceAmount'
                            handleOnChange={e => (currentEntity.invoiceAmount = e)}
                            value={currentEntity?.invoiceAmount}
                        />
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={6} md={6}>
                      <div className='form-group'>
                        <FormikControl
                            formik={formik}
                            readOnly={true}
                            control='input'
                            type='text'
                            label='Payment Date'
                            name='createdDate'
                            handleOnChange={e => (currentEntity.createdDate = e)}
                            value={currentEntity?.createdDate}
                        />
                      </div>
                    </Col>
                    <Col xs={6} md={6}>
                      <div className='form-group'>
                        <FormikControl
                            formik={formik}
                            readOnly={true}
                            control='input'
                            type='text'
                            label='Paid Amount'
                            name='amount'
                            handleOnChange={e => (currentEntity.amount = e)}
                            value={currentEntity?.amount}
                        />
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={6} md={6}>
                      <div className='form-group'>
                        <FormikControl
                            formik={formik}
                            readOnly={true}
                            control='input'
                            type='text'
                            label='VIZ ID'
                            name='vizShopCode'
                            handleOnChange={e => (currentEntity.vizShopCode = e)}
                            value={currentEntity?.vizShopCode}
                        />
                      </div>
                    </Col>
                    <Col xs={6} md={6}>
                      <div className='form-group'>
                        <FormikControl
                            formik={formik}
                            readOnly={true}
                            control='input'
                            type='text'
                            label='Shop Code'
                            name='shopCode'
                            handleOnChange={e => (currentEntity.shopCode = e)}
                            value={currentEntity?.shopCode}
                        />
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={6} md={6}>
                      <div className='form-group'>
                        <FormikControl
                            formik={formik}
                            readOnly={true}
                            control='input'
                            type='text'
                            label='Created By'
                            name='createdBy'
                            handleOnChange={e => (currentEntity.createdBy = e)}
                            value={currentEntity?.createdBy}
                        />
                      </div>
                    </Col>
                    <Col xs={6} md={6}>
                      <div className='form-group'>
                        <FormikControl
                            formik={formik}
                            readOnly={true}
                            control='input'
                            type='text'
                            label='Status'
                            name='status'
                            handleOnChange={e => (currentEntity.status = e)}
                            value={currentEntity?.status}
                        />
                      </div>
                    </Col>
                  </Row>

                  {
                    crudType !== 'view' &&
                    <Row>
                      <Col xs={6} md={6}>
                        <div className='form-group'>
                          <FormikControl
                              formik={formik}
                              control='input'
                              type='number'
                              label='Enter New Amount'
                              name='newAmount'
                              handleOnChange={e => (currentEntity.newAmount = e)}
                              value={currentEntity?.newAmount}
                          />
                        </div>
                      </Col>
                      <Col xs={6} md={6}>
                        <div className='form-group'>
                          <FormikControl
                              formik={formik}
                              control='input'
                              type='text'
                              label='TID #'
                              name='transactionId'
                              handleOnChange={e => (currentEntity.transactionId = e)}
                              value={currentEntity?.transactionId}
                          />
                        </div>
                      </Col>
                    </Row>                    
                  }
                </Container>
              </Modal.Body>

              <Modal.Footer>
                  <>
                    {
                      crudType !== 'view' &&
                      <input
                          type="submit"
                          className="btn btn-primary"
                          value={"Save"}
                        />
                    }
                    <Button
                      className="btn btn-default"
                      onClick={() => setModalShow(false)}
                    >
                      Close
                    </Button>
                  </>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state) => ({
  OneBillTransactionsList: state.OneBillManualSettlement.OneBillTransactionsList,
  OnBillTransactionDetail: state.OneBillManualSettlement.OnBillTransactionDetail,
  OnBillTransactionDetailById: state.OneBillManualSettlement.OnBillTransactionDetailById
});

export default connect(mapStateToProps, {
  getOneBillTransactionsForSettlement,
  getShopOrderTransactionDetailByPsid,
  getShopOrderTransactionDetailById,
  oneBillManualSettlement
})(OneBillManualSettlement);